module.exports = __webpack_public_path__ + "static/media/team3.cbea4452.png";